import React from 'react'
import WizardStartPage from '../wizard/WizardStartPage'

const RenterProfileEditPage: React.FC = () => <WizardStartPage isRenterProfileEdit={true} />

export default RenterProfileEditPage
